<p>Add the details of any life insurance policies to pass on to your next of kin in the event of your death.</p>
<hr />
<app-master-form [object]="object" [key]="key" [extraData]="extraData"></app-master-form >
